<!--Select Mode, Manual Vs. Batch-->
<div class="OptionSelectDiv">
	<h4>Select Mode:</h4>
	<div class="RadioGrid">
		<input type="radio" name="SelectMode" [(ngModel)]="SelectMode" id="Manual" value="Manual" />
		<label for="Manual">Manually Select Staff</label>

		<input style="margin-left: 10px" type="radio" name="SelectMode" [(ngModel)]="SelectMode" id="Batch" value="Batch" />
		<label for="Batch">Import File</label>
	</div>
</div>

<!--Manual Mode-->
<div *ngIf="SelectMode == 'Manual'" class="TopMarinExtra">
	<caass-ms-visitee-manual-mode> </caass-ms-visitee-manual-mode>
</div>

<!--Batch Mode-->
<div *ngIf="SelectMode == 'Batch'" class="TopMarinExtra">
	<caass-ms-visitee-batch-mode> </caass-ms-visitee-batch-mode>
</div>
